<template>
  <div :class="classnames">
    <div :class="`${ns}__section`">
      <MenuList>
        <template v-for="(option, index) in allOptions">
          <a
            :key="index"
            :class="optionClassnames(option.label)"
            :href="`#`"
            @click.prevent="handleOptionClick(option.label)"
            :data-is-selected="isSelected(option.label)"
          >
            <span :class="`${ns}__option-label`">{{ option.label }}</span>
            <span :class="`${ns}__option-value`">{{ option.value }}</span>
          </a>
        </template>
      </MenuList>
    </div>
    <div :class="`${ns}__section`">
      <p :class="`${ns}__compared-message`">{{ comparedMessage }}</p>
    </div>
    <!--
    <div :class="`${ns}__section ${ns}__section--is-disabled`">
      <MenuList>
        <template v-for="(option, index) in upgradeOptions">
          <a
            :class="optionClassnames(option.label)"
            :href="`#`"
            @click.prevent="handleOptionClick(option.label)"
          >
            <span :class="`${ns}__option-label`">{{ option.label }}</span>
            <span :class="`${ns}__option-value`">{{ option.value }}</span>
          </a>
        </template>
      </MenuList>
    </div>
    -->
    <!--
    <div v-if="shouldShowUpgradeCta" :class="`${ns}__section ${ns}__section--no-border`">
      <div :class="`${ns}__cta`">
        <AnchorButton :appearance="`cta`">
          <template slot="text">Upgrade</template>
        </AnchorButton>
      </div>
    </div>
    -->
  </div>
</template>

<script>
  import AnchorButton from '@/components/AnchorButton'
  import MenuList from '@/components/MenuList'

  import { bem } from '@/mixins/bem.js'
  import { getRanges } from '@/utils/dateRanges.js'

  const namespace = 'date-range-filter-combo-list'

  export default {
    name: 'DateRangeFilterComboList',
    components: {
      AnchorButton,
      MenuList
    },
    mixins: [ bem ],
    props: {
      comparedMessage: String,
      includedOptions: {
        default: function () {
          return getRanges()
        },
        type: Array
      },
      shouldShowUpgradeCta: Boolean,
      selectedDateRange: String,
      upgradeOptions: {
        default: function () {
          return []
        },
        type: Array
      }
    },
    computed: {
      allOptions: function () {
        return [
          ...this.includedOptions,
          ...this.upgradeOptions
        ]
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      handleOptionClick: function (option) {
        this.$emit('optionclick', option)
      },
      isSelected: function (rangeLabel) {
        return this.selectedDateRange === rangeLabel ? 'is-selected' : false
      },
      optionClassnames: function (rangeLabel) {
        const ns = this.namespace
        const isSelectedDateRange = this.selectedDateRange === rangeLabel
        const isSelectedModifier = isSelectedDateRange && `${ns}__option--is-selected`

        return [
          `${ns}__option`,
          isSelectedModifier
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/DateRangeFilterComboList.vue